import Typography from '@mui/material/Typography';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { ServerMessageHandler } from '@swf/notification';

const RejectedCommon: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const {
    data: { depositResult }
  } = useWizardContext();
  const message = depositResult?.message;

  return (
    <Typography component="div">
      {message?.defaultMessage ? (
        <ServerMessageHandler message={message.defaultMessage} />
      ) : (
        children
      )}
    </Typography>
  );
};

export default RejectedCommon;
